import { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';
import { TableDataJSON } from '../../../src/types/table-json';

export const meanAbsoluteDeviationDescription: CalculatorDescription = {
  id: CalculatorId.MEAN_ABSOLUTE_DEVIATION,
  title: 'Mean Absolute Deviation Calculator',
  metaTitle: 'Mean Absolute Deviation (MAD) Calculator - Measure Data Dispersion',
  description: 'Calculate the mean absolute deviation of your dataset to measure the average distance of values from the mean.',
  metaDescription: 'Free online mean absolute deviation calculator. Measure data dispersion with our easy-to-use statistical tool. Calculate population and sample MAD.',
  howTo: {
    title: 'How to calculate mean absolute deviation',
    steps: [
      'Enter your numeric data directly into the data table or upload a CSV file',
      'Use the "Select Data Column" control to choose which column of data to analyze',
      'The calculator will automatically compute both population and sample mean absolute deviation',
      'View the mean value and the average distance of values from it',
      'Examine the visualization to understand the data distribution and spread'
    ],
    graphic: {
      description: 'Visual representation of mean absolute deviation calculation'
    }
  },
  examples: [
    {
      title: 'Analyzing test score consistency',
      description: 'Measuring the average deviation of student performance',
      dataDescription: 'Test scores from a class of 25 students',
      insights: [
        'The MAD shows average distance from mean score',
        'Lower MAD indicates more consistent performance',
        'Higher MAD suggests wider score spread',
        'Compare with standard deviation for outlier impact'
      ],
      data: TableDataJSON.from({
        columns: [
          { 
            id: 'scores',
            name: 'Test Scores', 
            values: ['45', '55', '60', '65', '65', '70', '70', '72', '75', '75', '75', '78', '80', '80', '82', '85', '85', '85', '88', '90', '90', '92', '95', '98', '100'] 
          }
        ]
      })
    }
  ],
  relatedCalculators: [
    CalculatorId.VARIANCE,
    CalculatorId.STANDARD_DEVIATION,
    CalculatorId.MEAN
  ]
}; 